import {IFieldMeta} from 'entities/metadata';
import {IFormFieldWatcher} from 'shared/types/watchers';

import {getMonitorProgramCustomWatchers} from './custom-watchers/custom-watchers-monitor-programs';

type TGetCustomWatchersFunction = (fieldMeta: IFieldMeta, entityName?: string) => IFormFieldWatcher[] | undefined ;

export const getCustomWatchers: TGetCustomWatchersFunction = (fieldMeta, entityName) => {
    if (entityName === 'administration.monitor.programs'
        && getMonitorProgramCustomWatchers(fieldMeta)) return getMonitorProgramCustomWatchers(fieldMeta);

    return fieldMeta.watchers;
};
